import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {Debugger} from "debug";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {DashboardFilterKontroller} from "../dashboardFilter/dashboardFilter";
import {BasisKontroller} from "../../../basis/BasisKontroller";

require('./ingenMøterTips.scss');
const debug: Debugger = require('debug')('IngenMøterTipsKontroller');

export class IngenMøterTipsKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wdIngenMoeterTips', {
                bindings: {ingenMoeter: '<', filter: '<'},
                controller: IngenMøterTipsKontroller.forInjisering(),
                template: require('./ingenMøterTips.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            WebNavigasjon.regNavn,
            Kontekst.regNavn,
            IngenMøterTipsKontroller
        ]
    }

    constructor(private $scope: IScope,
                private navigasjon: WebNavigasjon,
                private kontekst: Kontekst) {
    }

    ingenMoeter: boolean; //settes via bindings/$onChanges
    filter: l.DashboardFiltervalg; //settes via bindings/$onChanges

    ingenMoeterTips(): 'ingenGrupper' | 'ingenGrupper_filtrert' | 'rediger_harGrupper_ingenMøter' | 'les_harGrupper_ingenMøter' {
        if (!this.ingenMoeter || !this.filter) return null;

        if (_.isEmpty(this.kontekst.autentiserteGrupper()))
            return 'ingenGrupper';
        if (_.isEmpty(this.filter.gruppeIder))
            return 'ingenGrupper_filtrert';
        if (this.kontekst.inneharTilgangsrolleINoenGruppe(l.TilgangsrolleMedlem.skrive))
            return 'rediger_harGrupper_ingenMøter';
        return 'les_harGrupper_ingenMøter';
    }

    erAlleGrupperValgt(){
        return this.filter && this.kontekst.autentiserteGrupper().length == this.filter.gruppeIder.length;
    }

    aapneFilterValg() {
        this.$scope.$root.$broadcast(DashboardFilterKontroller.eventer.visFilter);
    }

    aapneOpprettMoeteMeny(){
        this.$scope.$root.$broadcast(BasisKontroller.eventer.fokuserNyttMøteKnapp);
    }

    gaaTilOpprettPlan(){
        //går til trinn 1 i opprett-plan flyten, uavhengig av om filter inneholder én eller flere grupper
        this.navigasjon.gåTilOpprettPlan();
    }

    gaaTilGruppeoversikt() {
        this.navigasjon.gåTilGrupper();
    }

}
